import React from 'react';
import { Card, Collapse, List, Space, Tag, Typography } from 'antd';
import type { CompactTimelineProjection } from '../routes/execution/dashboardProjection';

const { Text } = Typography;

type Props = {
  timeline: CompactTimelineProjection;
};

function formatTs(value: string | null): string {
  if (!value) return '';
  try {
    return new Date(value).toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return value;
  }
}

function tagColor(entry: CompactTimelineProjection['entries'][0]): string {
  if (entry.kind === 'incident' || entry.kind === 'downtime') {
    return entry.completed ? 'default' : 'error';
  }
  if (entry.completed) return 'success';
  if (entry.inProgress) return 'processing';
  return 'default';
}

export const OperationalTimeline: React.FC<Props> = ({ timeline }) => {
  const { entries } = timeline;

  if (entries.length === 0) {
    return (
      <Card size="small" title="Хронология исполнения">
        <Text type="secondary">События исполнения появятся по мере выполнения маршрута.</Text>
      </Card>
    );
  }

  return (
    <Card size="small" title="Хронология исполнения" style={{ marginBottom: 16 }}>
      <List
        size="small"
        dataSource={entries}
        renderItem={(item) => (
          <List.Item>
            <Space direction="vertical" size={2} style={{ width: '100%' }}>
              <Space wrap align="start">
                {item.at ? (
                  <Text type="secondary" style={{ fontSize: 12, minWidth: 88 }}>
                    {formatTs(item.at)}
                  </Text>
                ) : null}
                <Tag color={tagColor(item)}>{item.label}</Tag>
              </Space>
              {item.summary ? <Text style={{ fontSize: 12 }}>{item.summary}</Text> : null}
              {item.contextLines.map((line) => (
                <Text key={line} type="secondary" style={{ fontSize: 12, display: 'block' }}>
                  {line}
                </Text>
              ))}
              {item.detailLines.length > 0 ? (
                <Collapse
                  ghost
                  size="small"
                  items={[
                    {
                      key: 'details',
                      label: <Text type="secondary" style={{ fontSize: 11 }}>Подробнее</Text>,
                      children: item.detailLines.map((line) => (
                        <Text key={line} type="secondary" style={{ fontSize: 11, display: 'block' }}>
                          {line}
                        </Text>
                      ))
                    }
                  ]}
                />
              ) : null}
            </Space>
          </List.Item>
        )}
      />
    </Card>
  );
};

export default OperationalTimeline;
